import React from 'react';
import { motion } from 'framer-motion';
import image1 from '../assets/images/History/WhatsApp Image 2025-04-14 at 6.29.44 PM.jpeg';
import image2 from '../assets/images/History/WhatsApp Image 2025-04-14 at 6.29.44 PM (1).jpeg';
import image3 from '../assets/images/History/WhatsApp Image 2025-04-14 at 6.29.44 PM (2).jpeg';
import image4 from '../assets/images/History/WhatsApp Image 2025-04-14 at 6.30.11 PM.jpeg';

const AboutUs = () => {
  return (
    <section id="about" className="py-20 bg-marina-50 relative">
      {/* Elementos decorativos */}
      <div className="absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-white to-marina-50"></div>
      <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-marina-50"></div>
      
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="md:w-1/2 mb-10 md:mb-0 md:pr-10"
          >
            <h2 className="section-title">Nuestra Historia</h2>
            <p className="text-gray-700 mb-6">
              La Barra Brava nació en 2010 de la pasión por los mariscos frescos y la cocina tradicional chilena. Fundado por la familia Martínez, pescadores de generación en generación, decidimos compartir los sabores del mar en un ambiente acogedor y único.
            </p>
            <p className="text-gray-700 mb-6">
              Nuestra filosofía es simple: obtener los mejores productos del mar, prepararlos con respeto y servirlos con amor. Trabajamos directamente con pescadores locales para garantizar la máxima frescura y calidad en cada plato.
            </p>
            <div className="flex flex-wrap items-center justify-center sm:justify-start gap-4 sm:gap-6 mb-6">
              <div className="flex flex-col items-center min-w-[80px]">
                <span className="text-2xl sm:text-3xl font-bold text-marina-700">14</span>
                <span className="text-xs sm:text-sm text-gray-600 text-center">Años de experiencia</span>
              </div>
              <div className="hidden sm:block w-px h-12 bg-marina-200"></div>
              <div className="flex flex-col items-center min-w-[80px]">
                <span className="text-2xl sm:text-3xl font-bold text-marina-700">+50</span>
                <span className="text-xs sm:text-sm text-gray-600 text-center">Platos tradicionales</span>
              </div>
              <div className="hidden sm:block w-px h-12 bg-marina-200"></div>
              <div className="flex flex-col items-center min-w-[80px]">
                <span className="text-2xl sm:text-3xl font-bold text-marina-700">+20K</span>
                <span className="text-xs sm:text-sm text-gray-600 text-center">Clientes satisfechos</span>
              </div>
            </div>
            <blockquote className="italic text-gray-600 border-l-4 border-marina-400 pl-4 py-2">
              "El mar nos da su mejor trabajo, nosotros solo lo honramos con nuestra cocina."
              <footer className="text-right mt-2 font-medium text-marina-700">- Carlos Martínez, Fundador</footer>
            </blockquote>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="md:w-1/2 grid grid-cols-2 gap-4"
          >
            <div className="relative h-48 md:h-64 rounded-lg overflow-hidden transform rotate-2 shadow-lg">
              <img 
                src={image1} 
                alt="Historia de La Barra Brava" 
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-marina-900/10 to-marina-900/30"></div>
            </div>
            <div className="relative h-48 md:h-64 rounded-lg overflow-hidden transform -rotate-2 shadow-lg mt-10">
              <img 
                src={image2} 
                alt="Nuestra tradición" 
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-marina-900/10 to-marina-900/30"></div>
            </div>
            <div className="relative h-48 md:h-64 rounded-lg overflow-hidden transform -rotate-1 shadow-lg">
              <img 
                src={image3} 
                alt="Productos del mar" 
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-marina-900/10 to-marina-900/30"></div>
            </div>
            <div className="relative h-48 md:h-64 rounded-lg overflow-hidden transform rotate-3 shadow-lg mt-8">
              <img 
                src={image4} 
                alt="Nuestro equipo" 
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-marina-900/10 to-marina-900/30"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
